import pricing from 'api/definitions/pricing';
import { FORMAT, dayjs } from 'utils/date';

import { SWAP_SHOPPABLE_PRICING_ACTIONS } from 'redux/modules/recipes/actions/types';

export const swapShoppableIngredientById = ({
  branchId,
  recipeId,
  ingredientId,
  groupId: shoppableProductIndex,
  swappedIngredient,
}) => {
  const { lineNumber, amountSelected, uom } = swappedIngredient;
  return {
    types: SWAP_SHOPPABLE_PRICING_ACTIONS,
    recipeId,
    ingredientId,
    groupId: shoppableProductIndex,
    swappedIngredient,
    apiCall: pricing.post({
      body: {
        products: [
          {
            lineNumber,
            quantity: {
              amount: amountSelected,
              uom,
            },
          },
        ],
        branchId,
        dates: [dayjs().format(FORMAT.ISO8601_DATE)],
        // Discounts should not be applied to Shoppable modal prices
        myWaitrose: false,
      },
    }),
  };
};
